export type DateStripScrollContainer = Pick<HTMLElement, 'scrollLeft' | 'clientWidth' | 'getBoundingClientRect' | 'scrollTo'>
export type DateStripScrollItem = Pick<HTMLElement, 'getBoundingClientRect'>

/**
 * Centers an active date-strip item within its scroll container without calling
 * `scrollIntoView`, which would bubble up and unintentionally scroll outer
 * layout ancestors (such as `.memberSurfaceFrame__scroll` in mobile member view).
 */
export const centerDateStripItem = (
  strip: DateStripScrollContainer,
  item: DateStripScrollItem,
): void => {
  const stripRect = strip.getBoundingClientRect()
  const itemRect = item.getBoundingClientRect()

  const targetLeft =
    strip.scrollLeft +
    itemRect.left -
    stripRect.left -
    (strip.clientWidth - itemRect.width) / 2

  const left = Math.max(0, targetLeft)

  if (typeof strip.scrollTo === 'function') {
    strip.scrollTo({
      left,
      behavior: 'smooth',
    })
  }
  strip.scrollLeft = left
}
